import classNames from 'classnames';
import { useTranslations } from 'next-intl';

const Stars = ({ count = 5 }: { count?: number }) => (
  <div className={styles.stars}>
    {Array.from({ length: count }).map((_, i) => (
      <svg
        key={i}
        viewBox="0 0 16 16"
        className={styles.star}
        aria-hidden="true"
      >
        <path d="M8 1.25l1.854 3.756 4.146.602-3 2.924.708 4.128L8 10.5l-3.708 1.16.708-4.128-3-2.924 4.146-.602L8 1.25z" />
      </svg>
    ))}
  </div>
);

const TESTIMONIALS = [
  {
    key: 'james',
    name: 'James T.',
    platform: 'App Store',
    avatar: 'linear-gradient(135deg,#7fa8ff,#b69bff)',
    letter: 'J',
  },
  {
    key: 'amanda',
    name: 'Amanda R.',
    platform: 'App Store',
    avatar: 'linear-gradient(135deg,#6ed7a6,#0b7b50)',
    letter: 'A',
  },
  {
    key: 'sophie',
    name: 'Sophie M.',
    platform: 'Google Play',
    avatar: 'linear-gradient(135deg,#f5a3c2,#c53d56)',
    letter: 'S',
  },
];

export const Section30 = () => {
  const t = useTranslations();
  return (
    <section className={styles.section}>
      <div className={styles.wrap}>
        <div className={styles.head}>
          <div className={styles.eyebrow}>
            {t('pages.useCases.memoryKeeping.testimonials.eyebrow')}
          </div>
          <h2 className={styles.title}>
            {t('pages.useCases.memoryKeeping.testimonials.title')}
          </h2>
          <div className={styles.ratingRow}>
            <Stars />
            <span className={styles.ratingScore}>4.8</span>
            <span className={styles.dot}>·</span>
            <span>
              {t('pages.useCases.memoryKeeping.testimonials.ratingNote')}
            </span>
          </div>
        </div>

        <div className={styles.grid}>
          {TESTIMONIALS.map((item) => (
            <div key={item.key} className={styles.card}>
              <Stars />
              <div className={styles.cardTitle}>
                {t(
                  `pages.useCases.memoryKeeping.testimonials.items.${item.key}.title`,
                )}
              </div>
              <blockquote className={styles.quote}>
                &ldquo;
                {t(
                  `pages.useCases.memoryKeeping.testimonials.items.${item.key}.quote`,
                )}
                &rdquo;
              </blockquote>
              <div className={styles.foot}>
                <div className={styles.author}>
                  <span
                    className={styles.avatar}
                    style={{ background: item.avatar }}
                  >
                    {item.letter}
                  </span>
                  <span className={styles.name}>{item.name}</span>
                </div>
                <span className={styles.platform}>{item.platform}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const styles = {
  section: 'marketing-dark:bg-mf-navy pt-[74px] pb-5',
  wrap: 'mx-auto max-w-[1200px] px-6 lg:px-10',
  head: 'mx-auto max-w-[680px] text-center',
  eyebrow:
    'mb-4 text-[13px] font-semibold uppercase tracking-[0.15em] text-mf-blue marketing-dark:text-mf-coral',
  title:
    'font-inter text-3xl font-extrabold leading-[1.1] tracking-[-0.02em] text-mf-off-black-600 marketing-dark:text-white sm:text-[40px]',
  ratingRow:
    'mt-6 flex flex-wrap items-center justify-center gap-3 text-sm text-mf-gray-500 marketing-dark:text-white/55',
  stars: 'flex gap-0.5',
  // Brand yellow on white; the softer pastel on navy.
  star: 'h-4 w-4 fill-mf-yellow marketing-dark:fill-[#FDE47A]',
  ratingScore: 'font-bold text-mf-off-black-600 marketing-dark:text-white',
  dot: 'text-mf-gray-300 marketing-dark:text-white/30',
  grid: 'mt-12 grid grid-cols-1 gap-[22px] text-left lg:grid-cols-3',
  card: classNames(
    'flex flex-col rounded-[18px] border p-7',
    'border-[#F0F0F0] bg-white',
    'marketing-dark:border-white/10 marketing-dark:bg-white/[0.03]',
  ),
  cardTitle:
    'mb-2 mt-2.5 text-[15px] font-bold text-mf-off-black-600 marketing-dark:text-white',
  quote:
    'flex-1 text-[15px] leading-[1.6] text-mf-gray-600 marketing-dark:text-white/72',
  foot: 'mt-4 flex items-center justify-between border-t border-[#F0F0F0] pt-4 marketing-dark:border-white/10',
  author: 'flex items-center gap-2.5',
  avatar:
    'flex h-9 w-9 items-center justify-center rounded-full text-sm font-bold text-white',
  name: 'text-sm font-semibold text-mf-off-black-600 marketing-dark:text-white',
  platform: 'text-xs text-mf-gray-500 marketing-dark:text-white/45',
};
